import { FeatureToggle, isFeatureToggleEnabled } from '@/hooks/useFeatureToggle';

export const MAINTENANCE_BANNER_ENABLED = true;
// 09:00 UTC == 10:00 in Lisbon (WEST) == 11:00 in Berlin (CEST).
export const MAINTENANCE_START = new Date('2026-10-13T09:00:00Z');

// Formats the start of the window in the user's own timezone, including the zone name.
export const formatMaintenanceStart = (locale: string) =>
    new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
    }).format(MAINTENANCE_START);

// The banner warns in advance, and stays up until it is switched off in another commit.
export const isMaintenanceAnnounced = () => MAINTENANCE_BANNER_ENABLED;

// The pages are only replaced once the window has actually started.
// The feature toggle lets us bypass the gate without a deployment.
export const isUnderMaintenance = (now: Date = new Date()) =>
    !isFeatureToggleEnabled(FeatureToggle.ENABLE_HIDE_MAINTENANCE_PAGES) && isMaintenanceAnnounced() && now >= MAINTENANCE_START;
